// 見積書マスタ一覧画面
import React, { useState, useCallback, useEffect } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogActions,
  Snackbar,
  Tooltip
} from '@material-ui/core';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import DeleteIcon from '@material-ui/icons/Delete';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DroppableProvided
} from 'react-beautiful-dnd';
import { useHistory, Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  estimateMasterData
} from '../GlobalState';
import {
  getEstimateMasterList,
  deleteEstimateMasterList,
  sortEstimateMasterItems
} from '../apicalls/esimateMaster';
import LoadingComponent from '../components/LoadingComponent';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { parsePrice } from '../utils';
import HelpIcon from '@material-ui/icons/Help';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TNewFifthItem } from '../types/estimate/estimateMaster';
import { TNewItem } from '../types/estimate/estimate';
import { TNewSecondItem } from '../types/estimate/estimate';
import { TNewThirdItem } from '../types/estimate/estimate';
import { TNewFourthItem } from '../types/estimate/estimate';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const EstimateMaster: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        padding: 10,
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      table1: {
        padding: 8
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      }
    })
  );

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();
  const history = useHistory();

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [estimateMasterApiData, setEstimateMasterApiData] =
    useRecoilState(estimateMasterData);
  const changeEstimateMasterApiData = useCallback(
    (newData: any) => setEstimateMasterApiData(newData),
    [setEstimateMasterApiData]
  );
  const [apiData, setApiData] = useState<any>(
    estimateMasterApiData !== null ? estimateMasterApiData : []
  );
  const [loading, setLoading] = useState(
    estimateMasterApiData !== null ? false : true
  );

  const [masterIds, setMasterIds] = useState<State>({ arr: [] });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);
  const [count, setCount] = useState(0);
  const [name, setName] = useState('');
  const [spec, setSpec] = useState('');
  const [authorMemo, setAuthorMemo] = useState('');

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  const getListOfEstimateMasters = useCallback(() => {
    getEstimateMasterList(name.trim(), spec.trim(), authorMemo.trim()).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
          return;
        }

        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
          return;
        }

        changeEstimateMasterApiData(data.data);
        setApiData(data.data);
        setCount(data.data.length);
        setLoading(false);

        if (data.error) {
          setErrorMessage(data.error);
          setOpen(true);
        } else {
          setMasterIds({ arr: [] });
          setChecked({ check: [] });
          setSelection(false);
        }
      }
    );
  }, [name, spec, authorMemo, changeLoggedInData, changeEstimateMasterApiData]);

  const deleteSelectedEstimateMasterList = () => {
    deleteEstimateMasterList(masterIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfEstimateMasters();
          }
        }
      }
    });
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const onDragEnd = (result: any) => {
    // ドロップ時の処理

    if (!result.destination) {
      // 範囲外へドロップした場合の処理
      return;
    }

    if (estimateMasterApiData == null) {
      return;
    }

    // 以下、reorder関数と同様の処理
    // apiDataのデータ型の問題でreorderそのままは使えない

    // 出発点のindex
    const startIndex = result.source.index;
    // 着地点のindex
    const endIndex = result.destination.index;

    const tmp = Array.from(apiData) as TNewItem[]; // apiDataの値を利用して、その順番を入れ替え
    const remove = tmp.splice(startIndex, 1);
    tmp.splice(endIndex, 0, remove[0]);
    setApiData(tmp); // ドラッグ&ドロップ後の並びをapiDataなどにset
    changeEstimateMasterApiData(tmp);
    sortItems(
      // 並び替えられた値を元にソート
      tmp
    );
  };

  /**
   * 並び替え保存
   */
  const sortItems = (items: TNewItem[]) => {
    const list_of_order_id: any = []; // 第一階層
    items.forEach((item: TNewItem) => {
      const itemIdObj = item.id;
      list_of_order_id.push(itemIdObj);
    });
    sortEstimateMasterItems(list_of_order_id).then(data => {
      // list_of_order_idを元に並べ替える
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            getEstimateMasterList(data.name, data.spec, data.authorMemo);
          }
        }
      }
    });
  };

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      let subjectArray: any = [];
      setMasterIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setMasterIds({ arr: subjectArray });
    } else {
      //subject ids
      setMasterIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };

  useEffect(() => {
    getListOfEstimateMasters();
  }, [getListOfEstimateMasters]);

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='estimate_master' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          {openSuccess ? (
            <Snackbar
              open={openSuccess}
              autoHideDuration={2000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {successMessage}
              </Alert>
            </Snackbar>
          ) : null}

          <div className={matches2 ? 'main-container-customer' : ''}>
            <div
              className={
                matches2
                  ? 'top-Container-customer'
                  : 'top-Container-customer-responsive'
              }
              style={{ gap: 10, paddingLeft: 0 }}
            >
              <input
                style={{
                  marginBottom: !matches2 ? 10 : 0,
                  backgroundColor: '#FFFFFF'
                }}
                className={classes.formControl1}
                placeholder='大項目'
                maxLength={20}
                onChange={text => {
                  setName(text.target.value);
                }}
              />
              <div>
                <input
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    marginBottom: !matches2 ? 10 : 0,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='仕様'
                  maxLength={40}
                  onChange={text => {
                    setSpec(text.target.value);
                  }}
                />
              </div>
              <Button
                style={{
                  marginLeft: matches2 ? 20 : 0,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
                onClick={getListOfEstimateMasters}
              >
                検索
              </Button>
            </div>
          </div>

          <Dialog
            open={openAlert}
            onClose={handleCloseAlert}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {'削除しますか？'}
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCloseAlert} color='primary'>
                キャンセル
              </Button>
              <Button
                onClick={() => {
                  deleteSelectedEstimateMasterList();
                }}
                color='primary'
                autoFocus
              >
                削除
              </Button>
            </DialogActions>
          </Dialog>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div className='table-top-container-customer'>
              <div className='question-position'>
                <div style={{ fontWeight: 'bold' }}>見積書マスタ</div>
                <CustomTooltip
                  title={tooltipContents.quotationMaster}
                  placement='right'
                >
                  <HelpIcon
                    color='action'
                    style={{ marginLeft: 8, marginTop: 4 }}
                  />
                </CustomTooltip>
              </div>
              <div>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 10,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  startIcon={<NoteAddIcon />}
                  onClick={() => history.push('/estimate-master/create')}
                >
                  新規作成
                </Button>

                <CustomTooltip
                  title={tooltipContents.estimateMasterSelectDelete}
                  placement='top'
                >
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginRight: 10,
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                      if (masterIds.arr.length === 0) {
                        alert('対象を選択してください。');
                      } else {
                        handleClickOpenAlert();
                      }
                    }}
                  >
                    選択削除
                  </Button>
                </CustomTooltip>
              </div>
            </div>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      <CustomTooltip
                        title={tooltipContents.selectDelete}
                        placement='top'
                      >
                        <Checkbox
                          checked={isSelected}
                          onClick={() => {
                            setSelection(!isSelected);
                            selectAllCheckBoxPressed();
                          }}
                          style={{
                            color: isSelected ? buttonColor : '#FFFFFF'
                          }}
                        />
                      </CustomTooltip>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='left'>
                      大項目
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='left'>
                      仕様
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      内訳合計
                    </StyledTableCell>
                    {/* <StyledTableCell
                      className={classes.table}
                      align="center"
                    ></StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId='droppable'>
                    {(droppableProvided: DroppableProvided) => (
                      <TableBody
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                      >
                        {apiData.map((row: any, index: number) => (
                          <Draggable
                            draggableId={index.toString()}
                            index={index}
                            key={index}
                          >
                            {provided => (
                              <StyledTableRow
                                key={row.id}
                                className='click_table_row'
                                title='編集'
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <StyledTableCell
                                  className={classes.table1}
                                  style={{ minWidth: 60 }}
                                  align='center'
                                >
                                  <CustomTooltip
                                    title={tooltipContents.selectDelete}
                                    placement='top'
                                  >
                                    <Checkbox
                                      checked={
                                        checked.check[index] ? true : false
                                      }
                                      onClick={() => {
                                        handleChange(index);
                                        let newArr = masterIds.arr;
                                        if (
                                          !checked.check[index] &&
                                          !pressed[index]
                                        ) {
                                          newArr.push(row.id);
                                          setMasterIds({ arr: newArr });
                                        } else {
                                          var ind = masterIds.arr.indexOf(
                                            row.id
                                          );
                                          if (ind !== -1)
                                            masterIds.arr.splice(ind, 1);
                                        }
                                        setCheckBoxSelected(!checkBoxSelected);
                                      }}
                                      style={{
                                        color: checked.check[index]
                                          ? buttonColor
                                          : '#758283'
                                      }}
                                    />
                                  </CustomTooltip>
                                </StyledTableCell>
                                <StyledTableCell
                                  className={classes.table1}
                                  style={{ minWidth: 90 }}
                                  align='left'
                                  onClick={() => {
                                    history.push(
                                      `/estimate-master/${row.id}/edit`,
                                      {
                                        state: row.id
                                      }
                                    );
                                  }}
                                >
                                  {row.name}
                                </StyledTableCell>
                                <StyledTableCell
                                  className={classes.table1}
                                  style={{ minWidth: 90 }}
                                  align='left'
                                  onClick={() => {
                                    history.push(
                                      `/estimate-master/${row.id}/edit`,
                                      {
                                        state: row.id
                                      }
                                    );
                                  }}
                                >
                                  {row.spec}
                                </StyledTableCell>
                                <StyledTableCell
                                  className={classes.table1}
                                  style={{ minWidth: 100 }}
                                  align='right'
                                  onClick={() => {
                                    history.push(
                                      `/estimate-master/${row.id}/edit`,
                                      {
                                        state: row.id
                                      }
                                    );
                                  }}
                                >
                                  {parsePrice(row.total_breakdown, '')}
                                </StyledTableCell>
                                {/* {<StyledTableCell
                                  className={classes.table1}
                                  align="center"
                                >
                                  <Button
                                    style={{ backgroundColor: buttonColor }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                      history.push(`/estimate-master/${row.id}/edit`, {
                                        state: row.id,
                                      });
                                    }}
                                  >
                                    編集
                                  </Button>
                                </StyledTableCell>} */}
                              </StyledTableRow>
                            )}
                          </Draggable>
                        ))}
                        {droppableProvided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
